var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03725 0 0 4.03725 0 9C0 13.9628 4.03725 18 9 18C13.9628 18 18 13.9628 18 9C18 4.03725 13.9628 0 9 0ZM9 1.5C13.1512 1.5 16.5 4.84875 16.5 9C16.5 13.1512 13.1512 16.5 9 16.5C4.84875 16.5 1.5 13.1512 1.5 9C1.5 4.84875 4.84875 1.5 9 1.5ZM9 4.5C7.35 4.5 6 5.85 6 7.5H7.5C7.5 6.66225 8.16225 6 9 6C9.83775 6 10.5 6.66225 10.5 7.5C10.4998 7.78028 10.4114 8.05339 10.2473 8.28062C10.0832 8.50785 9.85175 8.67766 9.58575 8.766L9.28125 8.859C8.98148 8.96001 8.72084 9.15231 8.5359 9.40895C8.35095 9.66558 8.25098 9.97367 8.25 10.29V11.25H9.75V10.2892L10.0545 10.1955C10.6196 10.0056 11.1111 9.64348 11.46 9.16007C11.8089 8.67666 11.9977 8.09617 12 7.5C12 5.85 10.65 4.5 9 4.5ZM8.25 12V13.5H9.75V12H8.25Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.0219acfe84f51d101416981c2bbc5baf.svg";
export { ForwardRef as ReactComponent };